import * as React from 'react';
import './PickUpRow.scss';
import Alert from 'src/components/common/Alert';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface IDeliverAddress {
  warehouseCode: string;
  suppliedFrom: string;
  description: string;
  quantity: number;
  name: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
}

interface IPickUpRowProps {
  address: IDeliverAddress;
  shipFromAddress: object;
  handleOnInputChange: (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => void;
  isBold: boolean;
  disabledPickup?: boolean;
  handleChangePickUp?: () => any;
  stateQty: string;
}

const PickUpRow: React.FC<IPickUpRowProps> = ({
  address,
  shipFromAddress,
  handleOnInputChange,
  isBold,
  disabledPickup,
  handleChangePickUp,
  stateQty
}) => {
  const [alert, setAlert] = React.useState({
    show: false,
    type: '',
    message: ''
  });

  React.useEffect(() => {
    const warehouse = shipFromAddress[address.warehouseCode];
    if (warehouse && Number(warehouse.qty) > Number(warehouse.available)) {
      if(stateQty === "In Stock No Backorder") {
        shipFromAddress[address.warehouseCode].qty = address.quantity;

        setAlert({
          show: true,
          type: 'info',
          message:
            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? `${i18n.t('common.NoitemsBackOrderedOnly')}`
              : `We are no longer accepting backorders for this product. Please select valid quantity from in stock location(s).`
        });
      } else {

        setAlert({
          show: true,
          type: 'info',
          message:
            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? `${i18n.t('common.itemsBackOrderedOnly')}`
              : `${Number(warehouse.qty) -
                  warehouse.available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
        });
        
      }
    }
  }, [shipFromAddress]);

  const handleCloseAlert = () => {
    setAlert({ show: false, type: '', message: '' });
  };

  return (
    <>
      <div className="rp-pick-up-row--addresses--row">
        <div className="rp-pick-up-row--addresses--address">
          <div
            className="rp-pick-up-row--addresses--address--state"
            style={isBold ? { fontWeight: 'bold' } : null}
          >
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? address.name.split(' PICK UP ONLY')[0]
              : address.name}
          </div>
        </div>
        <div
          className={
            disabledPickup
              ? 'rp-pick-up-row--addresses--stock-shrink'
              : 'rp-pick-up-row--addresses--stock'
          }
        >
          <div>
            {address.quantity > 0
              ? `${address.quantity} ${i18n.t('common.inStock')}`
              : `${i18n.t('common.outOfStock')}`}
          </div>
        </div>
        <div className="rp-pick-up-row--addresses--quantity">
          {disabledPickup ? (
            <span
              className="rp-pick-up-tab--address--change--pickup"
              onClick={handleChangePickUp}
            >
              {i18n.t('common.changePickupLocation')}
            </span>
          ) : (
            <input aria-label="Choose the quantity of this product you want to add to your cart from this location" disabled={stateQty === "In Stock No Backorder" && address.quantity < 1 ? true : false}
              value={
                shipFromAddress[address.warehouseCode]
                  ? shipFromAddress[address.warehouseCode].qty
                  : ''
              }
              onChange={e =>
                handleOnInputChange(
                  address.warehouseCode,
                  e.target.value,
                  address.quantity,
                  setAlert
                )
              }
            />
          )}
        </div>
      </div>
      {alert.show && (
        <Alert
          type={alert.type}
          styleClass={'rp-pick-up-row--tab-alert'}
          message={alert.message}
          icon={alert.type === 'error' ? 'rpds-error' : 'rpds-shipping'}
          handleCloseAlert={handleCloseAlert}
        />
      )}
    </>
  );
};

export default PickUpRow;
